import styled from "@emotion/styled";
import { Breadcrumbs, IconButton, Link } from "@mui/material";
import homePageIcon from "../../assets/imgs/homePageIcon.png";

const HomeIconPath = styled.img({
  height: "14.41px",
  width: "12px",
});
const TextPathSpan = styled.span({
  fontSize: "var(--body-b3-12-regular-size, 12px)",
  lineHeight: "13.96px",
  color: "#000",
});

interface breadcrumbsPath {
  pathName?: string;
  onClick?: () => void;
  showSearchResults?: boolean;
}

export const BreadcrumbsPath = ({
  pathName,
  onClick,
  showSearchResults,
}: breadcrumbsPath) => {
  return (
    <Breadcrumbs sx={{ marginTop: "24px" }} aria-label="breadcrumb">
      <Link href="/">
        <IconButton sx={{ marginBottom: "3px" }}>
          <HomeIconPath src={homePageIcon} alt="Home Page" />
        </IconButton>
      </Link>
      <Link
        style={{
          textDecoration: "none",
          color: "#000",
          cursor: onClick ? "pointer" : "text",
        }}
        onClick={onClick}
      >
        <TextPathSpan>{pathName}</TextPathSpan>
      </Link>
      {showSearchResults && (
        <Link style={{ textDecoration: "none", color: "#000", cursor: "text" }}>
          <TextPathSpan>Search Results</TextPathSpan>
        </Link>
      )}
    </Breadcrumbs>
  );
};
